import bootSetCookie from "./SetCookies";
export default async function bootDeleteCookie(name) {
    await bootSetCookie(name, "", -1);
}